<template>
  <div :class="$style.card">
    <div v-if="showTop" :class="$style.top">
      <div :class="$style.top_title">{{ title }}</div>
      <div :class="$style.top_actions">
        <slot name="actions"></slot>
      </div>
    </div>

    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: {
      type: String,
      default: "",
    },
    showTop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" module scoped>
.card {
  box-sizing: border-box;
  width: 100%;
  padding: rem(30) rem(50);
  margin-bottom: rem(30);
  background: $white;
  box-shadow: $box-shadow;
  border-radius: 4px;

  .top {
    height: rem(60);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .top_title {
      font-size: rem(20);
      font-weight: bold;
      color: #333333;
    }

    .top_actions {
      @include flex();
    }
  }
}
</style>